import { createContext, useContext } from "react";
import _ from 'lodash';
import { axiosApi } from "./axiosApi";


let EnvContext = createContext(null);

let envVarCache = {}

const useEnv = () => {
    return useContext(EnvContext);
}

const EnvProvider = ({ children }) => {

    const getVars = (names) => {

        let notCachedYetNames = _.difference(names, _.keys(envVarCache));
        let cachedValues = _.pick(envVarCache, names);

        if (notCachedYetNames.length === 0) {
            return new Promise((resolve, reject) => {
                resolve(cachedValues);
            });
        } else {
            return axiosApi.get(
                '/env', {
                    params: {
                        names: notCachedYetNames.join(',')
                    }
                }
            ).then(({ data }) => {
                return {
                    ...cachedValues,
                    ...data
                };
            });
        }
    }

    const getVar = (name) => {
        return getVars([name]).then((values) => {
            return values[name] || null;
        })
    }

    let value = { getVars, getVar };

    return <EnvContext.Provider value={value}>{children}</EnvContext.Provider>;
}

export {
    useEnv,
    EnvProvider,
}